import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

import Icon from "../../assets/icons/Icon";
import Button from "../UI/Button";
import Input from "../UI/Input";
import {
  AddBadlaOrder,
  AverageBadla,
  CommonModal,
  Difference,
  DollarRate,
  Opening,
  Rollover,
  WeeklySettle,
} from "../../Modal";
import { MODAL_MODE } from "../../Modal/Badla/AddBadlaOrder";

const MODAL_DATA = {
  weekly: {
    name: "weekly_settle",
    title: "Weekly Settlement",
    content: WeeklySettle,
  },
  upsert: {
    name: "create_badla",
    title: "Create Badla Order",
    content: AddBadlaOrder,
    size: "xl",
    mode: MODAL_MODE.ADD,
  },
  edit: {
    name: "edit_badla",
    title: "Edit Badla Order",
    content: AddBadlaOrder,
    size: "xl",
    mode: MODAL_MODE.EDIT,
  },
  end: {
    name: "end_badla",
    title: "End Badla Order",
    content: AddBadlaOrder,
    mode: MODAL_MODE.END,
  },
  buy: {
    name: "buy_badla",
    title: "Buy Order",
    content: AddBadlaOrder,
    mode: MODAL_MODE.BUY,
  },
  sell: {
    name: "sell_badla",
    title: "Sell Order",
    content: AddBadlaOrder,
    mode: MODAL_MODE.SELL,
  },
  dollar: {
    name: "doller_rate",
    title: "Doller Rate",
    content: DollarRate,
    size: "sm",
  },
  average: {
    name: "average_badla",
    title: "Average Badla Order",
    content: AverageBadla,
    isFooter: false,
  },
  opening: {
    name: "opening",
    title: "Edit Opening",
    content: Opening,
    size: "md",
  },
  difference: {
    name: "difference",
    title: "Edit Difference",
    content: Difference,
  },
  rollover: {
    name: "rollover",
    title: "Rollover",
    content: Rollover,
  },
};

const BadlaManageSubHead = forwardRef(
  ({ badlaOrderRefetch = () => {}, dollarRateRefetch = () => {} }, ref) => {
    const [isShow, setIsShow] = useState({
      isOpen: false,
      rowData: null,
      name: "",
      modalTitle: "",
      modalContent: null,
      modalMode: null,
      apiFlag: null,
    });

    // fetch list again every time on api flag change
    // useEffect(() => {
    //   if (isShow.apiFlag === null) return;

    //   badlaOrderRefetch();
    // }, [isShow.apiFlag]);

    // handle click actions
    const handleClickActions = useCallback(
      ({ action = "", rowData = null }) => {
        const matchModal = MODAL_DATA[action];

        setIsShow({
          isOpen: true,
          rowData: rowData,
          name: matchModal.name,
          modalTitle: matchModal.title,
          modalContent: matchModal.content,
          size: matchModal?.size,
          modalMode: matchModal.mode ?? null,
          isFooter: matchModal?.isFooter ?? true,
        });
      },
      [],
    );

    useImperativeHandle(ref, () => ({
      handleClickActions,
    }));

    return (
      <>
        <div className="date-input-main">
          <div className="row m-0 p-0 align-items-end">
            <div className="col-lg-2 col-6 m-0 p-1">
              <Button
                type="button"
                className="ban-man-box  warning-btn "
                title=" Weekly Settlement"
                data-action={{
                  name: "weekly_settle",
                  title: "Weekly Settlement",
                }}
                onClick={() => handleClickActions({ action: "weekly" })}
              >
                Weekly Settlement
              </Button>
            </div>
            <div className="col-lg-2 col-6 m-0 p-1">
              <Button
                type="button"
                className="ban-man-box  history-btn"
                title=" Create Badla Order "
                onClick={() => handleClickActions({ action: "upsert" })}
              >
                Create Badla Order
              </Button>
            </div>
            <div className="col-lg-2 col-6 m-0 p-1">
              <Button
                type="button"
                className="ban-man-box primary-btn"
                title="Doller Rate"
                onClick={() => handleClickActions({ action: "dollar" })}
              >
                Doller Rate
              </Button>
            </div>

            <div className="col-lg-2 col-6 m-0 p-1  ms-auto">
              <div className="date-input-box">
                <div className="ser_card">
                  <Icon name="Search" className="search_icon" />
                  <Input
                    type="text"
                    name="datetimes"
                    placeholder="search...  "
                    className="form-control searchbar_box"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {isShow.isOpen && (
          <CommonModal
            isShow={isShow.isOpen}
            size={isShow.size}
            handleShowHide={() =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
              }))
            }
            modalTitle={isShow.modalTitle}
            rowData={isShow.rowData}
            isFooter={isShow.isFooter}
          >
            {isShow.modalContent &&
              React.createElement(isShow.modalContent, {
                handleShowHide: () =>
                  setIsShow((prev) => ({
                    ...prev,
                    isOpen: false,
                    rowData: {},
                    name: "",
                    modalTitle: "",
                    apiFlag: !prev.apiFlag,
                  })),
                rowData: isShow.rowData,
                mode: isShow.modalMode,
                badlaOrderRefetch,
                dollarRateRefetch,
              })}
          </CommonModal>
        )}
      </>
    );
  },
);

export default BadlaManageSubHead;
